import { RealApiModule } from '../api/real-api/real-api.module';

export const environment = {
  production: true,
  sessionApi: RealApiModule,
  confGetter: () => undefined,
};
